module.exports = __webpack_public_path__ + "img/0604-b.8826b0eb.svg";